import {LoadingButton} from "@mui/lab";
import {Box, TextField, Button, Typography} from "@mui/material";
import {useState} from "react";
import {Link as RouterLink, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import BoxedLayout from "../../components/common/BoxedLayout";
import {passcodeRequest} from "../../services/dataService";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true)
      await passcodeRequest(email);
      setLoading(false)
      navigate(`/forgot-password-submit/${email}`);
    } catch (error) {
      setLoading(false)
      toast.error("Please enter valid email address.");
    }
  };

  return (
    <BoxedLayout>
      <Typography component="h1" variant="h5">
        Get validation code
      </Typography>
      <Typography marginTop={3}>
        To get a validation code, enter the e-mail address associated to your
        account.
      </Typography>
      <Box component="form" onSubmit={handleSubmit} marginTop={3}>
        <TextField
          margin="normal"
          fullWidth
          required
          id="Email"
          label={"E-mail Address"}
          name="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoFocus
          type="email"
          autoComplete="off"
        />
        <LoadingButton
          fullWidth
          size="large"
          variant="contained"
          color="primary"
          sx={{mt: 2}}
          type="submit"
          loading={loading}
        >
          Send OTP
        </LoadingButton>
        <Button
          component={RouterLink}
          to={`/login`}
          color="primary"
          fullWidth
          size="large"
          sx={{mt: 2}}
        >
          Back to login
        </Button>
      </Box>
    </BoxedLayout>
  );
};

export default ForgotPassword;
